module.exports = __webpack_public_path__ + "d262043d819749c416d9a93b4ebf5bd1.png";